import React, { useState, useRef, useEffect } from "react";
import Nav from "./Nav";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import WOW from "wowjs";

// DATA
import { DataNav } from "../data/DataNav";
import { DataContactOne } from "../data/DataContact";

function Header() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("click", handleClickOutside);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // side menu active
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuVisible(!isMenuVisible);
    setIsOverlayVisible(!isOverlayVisible);
  };

  const handleCloseMenu = () => {
    setIsMenuVisible(false);
    setIsOverlayVisible(false);
  };

  const handleOverlayClick = () => {
    setIsMenuVisible(false);
    setIsOverlayVisible(false);
  };

  // mobile menu
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuhome) => {
    setOpenMenu(openMenu === menuhome ? null : menuhome);
  };

  return (
    <div>
      <header className="tmp-header-area-start header-one">
        <div className="header-top-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-top-inner">
                  <div className="left-information-area">
                    <p className="left-top">
                      <i className="fa fa-bolt" aria-hidden="true"></i>{" "}
                      {DataContactOne.slogan}
                    </p>
                    <div className="location-area">
                      <i className="fa-light fa-location-dot" />
                      <Link to="#"> {DataContactOne.address}</Link>
                    </div>
                    <div className="working-time">
                      <i className="fa-light fa-clock" />
                      <p>Horaires de travail: {DataContactOne.workingHours}</p>
                    </div>
                  </div>
                  <div className="right-header-top">
                    <div className="social-area-transparent">
                      <span>Suivez-nous</span>

                      {DataContactOne.mediaLinks.map((item) => {
                        return (
                          <Link to="#" key={item.id}>
                            <i className={`fa-brands fa-${item.name}`} />
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-header-one-wrapper">
                <div className="header-mida-area">
                  <div
                    className="logo-area-start wow pulse"
                    data-wow-iteration="infinite"
                    data-wow-duration="2s"
                  >
                    <Link className="logo" to="/">
                      <img
                        width="188"
                        height="auto"
                        alt="Corporate_business_logo"
                        src="assets/images/logo/logo-01.png"
                      />
                    </Link>
                  </div>
                  <div className="mid-header-center">
                    {/* <p>
                        Need Help?{' '}
                        <Link to="#">
                          {' '}Request A Callback
                        </Link>
                      </p>
                      <div className="input-area">
                        <input
                          placeholder="Search..."
                          type="text"
                        />
                        <i className="fa-light fa-magnifying-glass" />
                      </div> */}
                  </div>
                  <Link className="tmp-btn btn-primary" to="/contact">
                    Get Consulting
                  </Link>
                </div>
                <div
                  className={`tmp-nav-area-one header--sticky ${
                    isSticky ? "sticky" : ""
                  }`}
                >
                  <div className="logo-md-sm-device">
                    <Link className="logo">
                      <img
                        className="wow pulse"
                        to="/"
                        data-wow-iteration="infinite"
                        data-wow-duration="2s"
                        style={{ width: "188px", height: "61px" }}
                        alt="corporate_business-logo"
                        src="assets/images/logo/logo-01.svg"
                      />
                    </Link>
                  </div>
                  <Nav />
                  <div className="actions-area">
                    <div
                      className="tmp-side-collups-area"
                      id="side-collups"
                      onClick={handleMenuToggle}
                    >
                      <svg
                        fill="none"
                        height="16"
                        viewBox="0 0 20 16"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect fill="#1F1F25" height="2" width="20" y="14" />
                        <rect fill="#1F1F25" height="2" width="20" y="7" />
                        <rect fill="#1F1F25" height="2" width="20" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="side-hide" className={isMenuVisible ? "show" : ""}>
        <div className="top-area">
          <Link
            to="/"
            className="logo-area wow pulse"
            data-wow-iteration="infinite"
            data-wow-duration="2s"
          >
            <img
              width="188"
              height="auto"
              src="assets/images/logo/logo-03.png"
              alt="logo"
            />
          </Link>
          <div className="close-icon-area">
            <div id="close-slide__main" onClick={handleOverlayClick}>
              <i className="fa-solid fa-x" />
            </div>
          </div>
        </div>
        <div className="body">
          <h5 className="title">{DataContactOne.desc2}</h5>
          <p className="disc">{DataContactOne.desc}</p>
          <div className="short-contact-area-side-collups">
            {/* single contact information */}
            <div className="single-contact-information-side">
              <i className="fa-solid fa-phone" />
              <div className="information">
                <span>Téléphone</span>
                <a href="#" className="number">
                  {DataContactOne.phone}
                </a>
                <br />
                <a href="#" className="number">
                  {DataContactOne.phone2}
                </a>
              </div>
            </div>
            {/* single contact information end */}
            {/* single contact information */}
            <div className="single-contact-information-side">
              <i className="fa-light fa-envelope" />
              <div className="information">
                <span>E-mail</span>
                <a href="#" className="number">
                  {DataContactOne.email}
                </a>
              </div>
            </div>
            {/* single contact information end */}
            {/* single contact information */}
            <div className="single-contact-information-side">
              <i className="fa-sharp fa-light fa-location-dot" />
              <div className="information">
                <span>Siège</span>
                <a href="#" className="number">
                  {DataContactOne.address}
                </a>
              </div>
            </div>
            {/* single contact information end */}
          </div>
          {/* social area start */}
          <ul className="social-icons solid-social-icons rounded-social-icons">
            {DataContactOne?.mediaLinks.map((item) => {
              if (item.name === "facebook") {
                return (
                  <li key={item.id}>
                    <a href="#">
                      <i className={`fa-brands fa-${item.name}-f`} />
                    </a>
                  </li>
                );
              } else {
                return (
                  <li key={item.id}>
                    <a href="#">
                      <i className={`fa-brands fa-${item.name}`} />
                    </a>
                  </li>
                );
              }
            })}
          </ul>
          {/* social area end */}
        </div>

        {/* mobile menu area start */}
        <div className="mobile-menu-main">
          <nav className="nav-main mainmenu-nav mt--30">
            <ul className="mainmenu metismenu" id="mobile-menu-active">
              {DataNav.map((item) => {
                return (
                  <li key={item.id}>
                    <Link to={item.link} className="main">
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
        {/* mobile menu area end */}
      </div>

      <div
        id="overlay_every-where"
        className={isOverlayVisible ? "bgshow" : ""}
        onClick={handleOverlayClick}
      ></div>
    </div>
  );
}

export default Header;
